import { Injectable } from "@angular/core";

import { first } from "rxjs/operators";

import { DffGroupedContent, SessionStorage } from "@dffedb/util";
import { AktuelBrugerObserver } from "@e-forsyning/common/bruger";
import { AktuelInstallationObserver } from "@e-forsyning/common/installation";
import { DffMailInternal, EforsyningMailBuilderService, EforsyningMailSenderService } from "@e-forsyning/common/mail";
import { EforsyningIndstilling, UmbracoIndstillingerObserver } from "@e-forsyning/common/umbraco-indstillinger";

import { SendFejlforbrugMailModel } from "./send-fejlforbrug-mail.model";

@Injectable({ providedIn: "root" })
export class SendFejlforbrugMailService {
    private subject = "Meddelelse fra bruger på E|Forsyning";

    constructor(
        private readonly eforsyningMailBuilder: EforsyningMailBuilderService,
        private readonly mailSender: EforsyningMailSenderService,
        private readonly umbracoIndstillingerObserver: UmbracoIndstillingerObserver,
        private readonly aktuelBrugerObserver: AktuelBrugerObserver,
        private readonly aktuelInstallationObserver: AktuelInstallationObserver,
        private readonly sessionStorage: SessionStorage
    ) {}

    public async sendMail(model: SendFejlforbrugMailModel): Promise<void> {
        const mail = await this.genererMail(model);
        return this.mailSender.sendMitforbrugDatafejlMail(mail);
    }

    private async genererMail(model: SendFejlforbrugMailModel): Promise<DffMailInternal> {
        const indstillinger = await this.umbracoIndstillingerObserver.valueChanges.pipe(first()).toPromise();
        const to = indstillinger.aktuelEforsyning.firmaInfo.email + ";udv@softvaerket.dk";

        //  const forsyningIndstillinger$ = forsyningIndstillingerService.hentForsyningIndstillinger()
        const mailData = JSON.stringify(await this.modelToGroupedContent(model, indstillinger.aktuelEforsyning));
        const rawCredentials = await this.sessionStorage.select("credentials").pipe(first()).toPromise();
        const allCredentials = JSON.parse(rawCredentials || null) || {};
        const nodeId = allCredentials["bruger"];

        const result: DffMailInternal = {
            sideId: nodeId, // this.installation.forsyningIndstillinger.sideId,
            to,
            //subject: this.subject,
            model: mailData
        };
        return result;
    }

    private async modelToGroupedContent(model: SendFejlforbrugMailModel, indstillinger: EforsyningIndstilling): Promise<DffGroupedContent> {
        const bruger = await this.aktuelBrugerObserver.valueChanges.pipe(first()).toPromise();
        const installation = await this.aktuelInstallationObserver.valueChanges.pipe(first()).toPromise();
        return {
            groups: [
                {
                    title: "Oplysninger",
                    rows: [
                        { key: "Mail", value: model.email },
                        { key: "Navn", value: bruger.navn },
                        { key: "Telefon", value: model.telefon },
                        { key: "Ejendom", value: installation.ejendomNr + "" },
                        { key: "Installation", value: installation.installationNr + "" },
                        { key: "Bruger", value: bruger.id + "" },
                        { key: "Værk", value: indstillinger.firmaInfo.firmaNavn },
                        { key: "Årstal fra graf", value: model.aar + "" },
                        { key: "Måned fra graf", value: model.maaned + "" },
                        { key: "Visningstype", value: model.visningstype },
                        { key: "Besked fra bruger", value: model.beskrivelse.replace(/\n/g, "<br>") }
                    ]
                }
            ]
        };
    }
}
